// extracted by mini-css-extract-plugin
export default {"left":"ArrowBtn_left__Njm-X","right":"ArrowBtn_right__D0vO5"};